export default __webpack_public_path__ + "static/media/promotions-active.d7949bee.svg";